
<template lang="pug">
    Tabs.form-entry-list.pagination
        el-card.contains-table(shadow="always")
            //- :row-link-config="formEntriesPaginated.link"
            //- h1 Test
            paginated-items(
                scope="ex"
                type="form_entry"
                :loading="loading"
                :items="formEntriesPaginated.items"
                :filters="filters"
                :show-filters="showFilters"
                :variables="formEntriesPaginated.variables"
                :all-columns="allColumns"
                :active-columns="activeColumns"
                :page-info="formEntriesPaginated.pageInfo"
                :sort="sort"
                @pagination-size-change="handleSizeChange"
                @pagination-current-change="handleCurrentChange"
                @show-table-columns="handleColsShow"
                @change-filter="handleFilterInputChange"
                @change-sort="handleSortInputChange"
                @click="openFieldsDrawer"
            )
                template(slot="top")
                    el-row.table-top(type="flex" justify="space-between")
                        .row
                            .left
                                //- el-button(type="primary" size="mini" icon="el-icon-fa-plus fas" @click="addFormEntry")
                                //-     | {{ $t('New Form Entry') }}
                            .middle.hide-on-empty
                                span.info
                                    | {{ $t('Found {total} form entries', { total: formEntriesPaginated.pageInfo.total }) }}
                                template(v-if="bulk.action || formEntriesPaginated.pageInfo.selection.total > 0")
                                    hr.vertical
                                    span.info {{ $t('{total} selected', { total: formEntriesPaginated.pageInfo.selection.total }) }}
                            .right.hide-on-empty
                                el-select.form-filter(
                                    v-if="formNameOptions.length > 1"
                                    :value="formNameFilter"
                                    clearable
                                    filterable
                                    size="mini"
                                    :placeholder="$t('All forms')"
                                    @change="handleFormNameFilterChange"
                                )
                                    el-option(
                                        v-for="opt in formNameOptions"
                                        :key="opt.value || opt.key"
                                        :label="opt.label"
                                        :value="opt.value || opt.key"
                                    )
                                hr.vertical(v-if="formNameOptions.length > 1")
                                .bulk-actions
                                    el-select(
                                        v-model="bulk.action"
                                        size="mini"
                                        :placeholder="$t('Select bulk action...')"
                                        clearable
                                    )
                                        el-option(
                                            v-for="item in bulk.options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        )
                                    transition(name="slide-decent-left")
                                        el-button(
                                            v-if="formEntriesPaginated.pageInfo.selection.total > 0 || bulk.action"
                                            type="primary"
                                            size="mini"
                                            :disabled="!bulk.action || formEntriesPaginated.pageInfo.selection.total <= 0"
                                            icon="el-icon-fa-check fas"
                                            @click.stop.prevent="event => handleBulkAction()"
                                        )
                                            | {{ $t('Go') }}
                                hr.vertical
                                el-button(
                                    plain
                                    size="mini"
                                    type="primary"
                                    icon="el-icon-fa-filter fas"
                                    @click="toggleFilterVisiblity"
                                    :disabled="disable.showFilters || hasFilters"
                                )
                                    span(v-if="showFilters") {{ $t('Hide filters') }}
                                    span(v-else) {{ $t('Show filters') }}
                                hr.vertical
                                el-button.fe-info-btn(
                                    size="mini"
                                    type="primary"
                                    plain
                                    :class="{ 'is-active': showInfo }"
                                    @click="showInfo = !showInfo"
                                )
                                    i.el-icon-fa-question-circle.fas
                                    | &nbsp;Hilfe &amp; Anleitung
                    transition(name="fe-info-slide")
                        .fe-info-content(v-if="showInfo")
                            button.fe-info-close(@click="showInfo = false")
                                i.el-icon-close
                            h4 Formulareinträge — Übersicht
                            p.fe-info-description {{ $t('view.description') }}
                            .fe-info-grid
                                .fe-info-section
                                    .fe-info-title
                                        i.el-icon-fa-list-ul.fas
                                        | &nbsp;Anfrage ansehen
                                    ul
                                        li {{ $t('help.row_click') }}
                                        li {{ $t('help.fields_nav') }}
                                        li {{ $t('help.arrow_keys') }}
                                .fe-info-section
                                    .fe-info-title
                                        i.el-icon-fa-envelope.fas
                                        | &nbsp;E-Mail lesen
                                    ul
                                        li {{ $t('help.email_open') }}
                                        li {{ $t('help.email_nav') }}
                                        li {{ $t('help.email_links') }}
                                .fe-info-section
                                    .fe-info-title
                                        i.el-icon-fa-filter.fas
                                        | &nbsp;Suchen &amp; Filtern
                                    ul
                                        li {{ $t('help.form_filter') }}
                                        li {{ $t('help.column_filters') }}
                                        li {{ $t('help.columns_config') }}
                                .fe-info-section
                                    .fe-info-title
                                        i.el-icon-fa-check-square.fas
                                        | &nbsp;Mehrere auf einmal
                                    ul
                                        li {{ $t('help.bulk_select') }}
                                        li {{ $t('help.bulk_action') }}
                                        li {{ $t('help.bulk_delete') }}
                                        li {{ $t('help.bulk_export') }}
                                .fe-info-section
                                    .fe-info-title
                                        i.el-icon-fa-file-csv.fas
                                        | &nbsp;Als Tabelle herunterladen
                                    ul
                                        li {{ $t('help.csv_export') }}
                                        li {{ $t('help.csv_filters') }}
                template(v-slot:actions:th)
                    .col-left(v-if="!showFilters")
                        //- https://codepen.io/danielhoppener/pen/xxKVbey
                        check-all(
                            :total="formEntriesPaginated.pageInfo.total"
                            :show-dropdown="formEntriesPaginated.pageInfo.lastPage > 1"
                            :checked="bulkSelection"
                            :is-indeterminate="selectionIndeterminate"
                            @check-all="checkAll"
                            @check-visible="checkVisible"
                        )
                template(v-slot:actions:filter)
                    .col-left
                        check-all(
                            :total="formEntriesPaginated.pageInfo.total"
                            :show-dropdown="formEntriesPaginated.pageInfo.lastPage > 1"
                            :checked="bulkSelection"
                            :is-indeterminate="selectionIndeterminate"
                            @check-all="checkAll"
                            @check-visible="checkVisible"
                        )
                //- template(v-slot:actions="{ item }")
                //-     el-checkbox(
                //-         :key="item.id"
                //-         :value="isChecked(item.id)"
                //-         @change="checkItem(item)"
                //-     )
                template(v-slot:actions="{ item }")
                    el-checkbox(
                        :key="item.id"
                        :value="isChecked(item.id)"
                        @change="checkItem(item)"
                    )
                    el-tooltip(:content="item.read_at ? $t('Mark as unread') : $t('Mark as read')" placement="top")
                        el-button.read-button(
                            plain
                            circle
                            size="mini"
                            :icon="item.read_at ? 'el-icon-fa-envelope far' : 'el-icon-fa-envelope-open far'"
                            @click.stop.prevent="toggleEntryRead(item)"
                        )
                    el-tooltip(:content="$t('Sent email')" placement="top")
                        el-button.email-button(
                            v-if="item.created_by_email && item.email_data && item.email_data.length"
                            plain
                            circle
                            size="mini"
                            type="primary"
                            icon="el-icon-fa-envelope far"
                            @click.stop.prevent="openModal(item)"
                        )
                    el-tooltip(:content="$t('Form fields')" placement="top")
                        el-button(
                            v-if="item.fields && item.fields.length"
                            plain
                            circle
                            size="mini"
                            type="primary"
                            icon="el-icon-fa-list-ul fas"
                            @click.stop.prevent="openFieldsDrawer(item)"
                        )
                    //- The submission became a ticket and is worked on there —
                    //- same handover the inbox gives a ticket-owned thread.
                    el-tooltip(v-if="item.ticket" :content="$t('Belongs to ticket {number}', { number: item.ticket.number })" placement="top")
                        el-button.ticket-button(
                            plain
                            circle
                            size="mini"
                            type="primary"
                            icon="el-icon-fa-ticket fas"
                            @click.stop.prevent="openTicket(item.ticket)"
                        )
        el-drawer.email-preview-drawer(
            :title="modal.title"
            :visible.sync="modal.visibility"
            direction="rtl"
            size="40%"
            @closed="resetModal"
        )
            .eml-preview.eml-preview--with-nav
                .eml-meta
                    .from-to
                        .from(v-if="modal.from")
                            b {{ $t('From') }}:
                            span.pill(v-html="mailify(modal.from)")
                        .to(v-if="modal.to")
                            b {{ $t('To') }}:
                            span.pill(v-html="mailify(modal.to)")
                        .cc(v-if="modal.cc")
                            b {{ $t('Cc') }}:
                            span.pill(v-html="mailify(modal.cc)")
                        .bcc(v-if="modal.bcc")
                            b {{ $t('Bcc') }}:
                            span.pill(v-html="mailify(modal.bcc)")
                        .date(v-if="modal.datetime")
                            b {{ $t('Date / time') }}:
                            span.pill {{ modal.datetime }}
                    .subject(v-if="modal.subject")
                        b {{ $t('Subject') }}:
                        span {{ modal.subject }}
                    .attachments(v-if="modal.attachments.length")
                        b {{ modal.attachments.length > 1 ? $t('Attachments') : $t('Attachment') }}:
                        ul
                            li(v-for="file in modal.attachments" :key="file.id")
                                a(
                                    :href="getDownloadLink(file)"
                                    :download="file.preferred_name || file.name"
                                ) {{ file.preferred_name || file.name }}
                .eml-preview__body-scroll(v-loading="modal.loading")
                    iframe.eml-preview__iframe(
                        ref="preview-iframe"
                        frameBorder="0"
                    )
            .eml-preview__nav
                el-button(
                    plain
                    size="mini"
                    type="danger"
                    icon="el-icon-fa-trash-alt fas"
                    :disabled="!modal.item"
                    @click="deleteDrawerItem(modal.item)"
                )
                span.nav-pos {{ modalGlobalPos }} / {{ formEntriesPaginated.pageInfo.total }}
                .nav-btns
                    el-button(
                        plain
                        size="mini"
                        icon="el-icon-fa-chevron-up fas"
                        :disabled="modal.index <= 0 && formEntriesPaginated.pageInfo.currentPage <= 1"
                        @click="navigateModal(-1)"
                    ) {{ $t('Previous') }}
                    el-button(
                        plain
                        size="mini"
                        :disabled="modal.index >= formEntriesPaginated.items.length - 1 && formEntriesPaginated.pageInfo.currentPage >= formEntriesPaginated.pageInfo.lastPage"
                        @click="navigateModal(1)"
                    )
                        | {{ $t('Next') }}&nbsp;
                        i.el-icon-fa-chevron-down.fas
        el-drawer.fields-drawer(
            :title="fieldsDrawer.title"
            :visible.sync="fieldsDrawer.visible"
            direction="rtl"
            size="480px"
            @closed="resetFieldsDrawer"
        )
            .fields-drawer__body
                .fields-drawer__field(v-if="fieldsDrawer.item && fieldsDrawer.item.created_at")
                    .fields-drawer__field-title {{ $t('Date / time') }}
                    .fields-drawer__field-value {{ fieldsDrawer.item.created_at | timestamp2date($t('yyyy-MM-dd') + ', HH:mm') }}
                .fields-drawer__field(v-if="fieldsDrawer.item && fieldsDrawer.item.created_by_name")
                    .fields-drawer__field-title {{ $t('Name') }}
                    .fields-drawer__field-value {{ fieldsDrawer.item.created_by_name }}
                .fields-drawer__field(v-if="fieldsDrawer.item && fieldsDrawer.item.created_by_email")
                    .fields-drawer__field-title {{ $t('Email') }}
                    .fields-drawer__field-value(v-html="mailify(fieldsDrawer.item.created_by_email)")
                .fields-drawer__field(
                    v-for="field in fieldsDrawer.fields"
                    :key="field.id"
                )
                    .fields-drawer__field-title {{ field.title }}
                    .fields-drawer__field-value(v-if="field.type === 'upload'")
                        template(v-if="field.files && field.files.length")
                            a.file(
                                v-for="file in field.files"
                                :key="file.id"
                                :href="getDownloadLink(file)"
                                :download="file.preferred_name || file.name"
                                @click.prevent="downloadFile"
                            ) {{ file.preferred_name || file.name }}
                        span(v-else-if="field.value") {{ field.value }}
                    .fields-drawer__field-value.field-tags(v-else-if="field.type === 'multi-select'")
                        span.field-tag(v-for="val in (field.values || [])" :key="val.key") {{ val.value }}
                    .fields-drawer__field-value(v-else v-html="linkify(getAdditionalFormFieldValue(field))")
            router-link.fields-drawer__ticket(
                v-if="fieldsDrawer.item && fieldsDrawer.item.ticket"
                :to="{ name: 'ticket-detail', params: { id: fieldsDrawer.item.ticket.id } }"
            )
                i.el-icon-fa-ticket.fas
                span.fields-drawer__ticket-text
                    strong {{ $t('Belongs to ticket {number}', { number: fieldsDrawer.item.ticket.number }) }}
                    span.fields-drawer__ticket-subject(v-if="fieldsDrawer.item.ticket.subject") {{ fieldsDrawer.item.ticket.subject }}
                span.fields-drawer__ticket-go
                    | {{ $t('Open ticket') }}
                    i.el-icon-fa-arrow-right.fas
            .fields-drawer__nav
                el-button(
                    plain
                    size="mini"
                    type="danger"
                    icon="el-icon-fa-trash-alt fas"
                    :disabled="!fieldsDrawer.item"
                    @click="deleteDrawerItem(fieldsDrawer.item)"
                )
                span.nav-pos {{ fieldsDrawerGlobalPos }} / {{ formEntriesPaginated.pageInfo.total }}
                .nav-btns
                    el-button(
                        plain
                        size="mini"
                        icon="el-icon-fa-chevron-up fas"
                        :disabled="fieldsDrawer.index <= 0 && formEntriesPaginated.pageInfo.currentPage <= 1"
                        @click="navigateFieldsDrawer(-1)"
                    ) {{ $t('Previous') }}
                    el-button(
                        plain
                        size="mini"
                        :disabled="fieldsDrawer.index >= formEntriesPaginated.items.length - 1 && formEntriesPaginated.pageInfo.currentPage >= formEntriesPaginated.pageInfo.lastPage"
                        @click="navigateFieldsDrawer(1)"
                    )
                        | {{ $t('Next') }}&nbsp;
                        i.el-icon-fa-chevron-down.fas
        el-dialog.bulk-action-dialog(
            :title="bulk.modal.title"
            :visible.sync="bulk.modal.visibility"
            :close-on-click-modal="false"
            :width="bulk.modal.width"
            top="10vh"
            @closed="resetBulkModal"
        )
            .bulk-modal-body(v-if="bulk.modal.body" v-html="bulk.modal.body")
            template(slot="footer")
                .modal-footer
                    .left
                        el-button(
                            v-for="button in bulk.modal.buttons.left" :key="button.label"
                            v-if="button.action"
                            :size="button.size || 'mini'"
                            :type="button.type"
                            :icon="button.icon"
                            @click="button.action"
                        ) {{ button.label }}
                    .right
                        el-button(
                            v-for="button in bulk.modal.buttons.right" :key="button.label"
                            v-if="button.action"
                            :size="button.size || 'mini'"
                            :type="button.type"
                            :icon="button.icon"
                            @click="button.action"
                        ) {{ button.label }}
            //- template(booking="footer")
                .modal-footer
                    .left
                        //- ...
                    .right
                        el-button(
                            size="mini"
                            icon="el-icon-fa-times fas"
                            @click="closeModal"
                        ) {{ $t('Dismiss') }}
                        el-button(
                            :disabled="modalLoading"
                            size="mini"
                            type="warning"
                            icon="el-icon-fa-paper-plane fas"
                            @click="resendEmail"
                            disabled
                        ) {{ $t('Send email again') }}
</template>

<i18n>
{
    "en": {
        "Belongs to ticket {number}": "Belongs to ticket {number}",
        "view.description": "Here you can see all enquiries and messages received through your forms.",
        "help.row_click": "Click a row to see all details of the enquiry on the right-hand side",
        "help.fields_nav": "Use the next/previous buttons to switch to the next or previous enquiry",
        "help.arrow_keys": "You can also use the ↑↓ arrow keys on your keyboard to navigate",
        "help.email_open": "Click the envelope icon to read the email that was sent at the time",
        "help.email_nav": "In the email view you can also page through the entries with next/previous",
        "help.email_links": "Email addresses and web addresses in the details are directly clickable",
        "help.form_filter": "In the top right you can select which form you want to view",
        "help.column_filters": "Use \"Show filters\" to search the list for specific terms",
        "help.columns_config": "Use the columns icon in the top right to choose which columns are displayed",
        "help.bulk_select": "Tick the checkboxes on the left of each row to select multiple entries at once",
        "help.bulk_action": "Then choose an action in the top right and click \"Go\"",
        "help.bulk_delete": "\"Delete\" permanently removes all selected entries",
        "help.bulk_export": "\"Export CSV\" lets you download the entries as a table and open them in Excel",
        "help.csv_export": "Only the entries currently visible in the list are ever exported",
        "help.csv_filters": "Use the filters to export only specific entries",
        "Found {total} form entries": "Found {total} form entries",
        "{total} selected": "{total} selected",
        "Do you really want to delete {total} form entries?": "Do you really want to delete {total} form entries?",
        "Delete {total} form entries": "Delete {total} form entries"
    },
    "de": {
        "Belongs to ticket {number}": "Gehört zu Ticket {number}",
        "Mark as read": "Als gelesen markieren",
        "Mark as unread": "Als ungelesen markieren",
        "Open ticket": "Zum Ticket",
        "All forms": "Alle Formulare",
        "Form fields": "Formularfelder",
        "Name": "Name",
        "Email": "E-Mail",
        "From": "Von",
        "To": "An",
        "CC": "CC",
        "BCC": "BCC",
        "Go": "Ausführen",
        "Selected form entries": "Markierte Formulareinträge",
        "Select bulk action...": "Massenaktion auswählen...",
        "New Form Entry": "Neuer Formulareintrag",
        "Show filters": "Filter anzeigen",
        "Hide filters": "Filter verbergen",
        "Form entry list could not be fetched.": "Formulareintragliste konnte nicht abgerufen werden.",
        "Sent email": "Gesendete E-Mail",
        "Error loading email preview": "Fehler beim Laden der E-Mail-Vorschau",
        "Send email again": "Email erneut versenden",
        "Email has been sent to": "Email wurde versendet an",
        "An additional email was also sent to": "Eine weitere Email wurde versendet an",
        "Subject": "Betreff",
        "Email content": "Email Inhalt",
        "Date / time": "Datum / Uhrzeit",
        "Attachment": "Anhang",
        "Kind regards": "Freundliche Grüße",
        "Found {total} form entries": "{total} Formulareinträge gefunden",
        "{total} selected": "{total} ausgewählt",
        "Delete...": "Löschen",
        "Do you really want to delete {total} form entries?": "Sollen {total} Formulareinträge wirklich gelöscht werden?",
        "Do you really want to delete the selected form entry?": "Soll der ausgewählte Formulareintrag wirklich gelöscht werden?",
        "Delete {total} form entries": "{total} Formulareinträge löschen",
        "Bulk action processed successfully!": "Massenaktion erfolgreich verarbeitet!",
        "view.description": "Hier sehen Sie alle Anfragen und Nachrichten die über Ihre Formulare eingegangen sind.",
        "Help & Instructions": "Hilfe &amp; Anleitung",
        "Form entries — Overview": "Formulareinträge — Kurzanleitung",
        "Email preview": "E-Mail-Vorschau",
        "help.row_click": "Klicken Sie auf eine Zeile um alle Angaben der Anfrage auf der rechten Seite zu sehen",
        "help.fields_nav": "Mit den Vor/Zurück-Schaltflächen können Sie zur nächsten oder vorherigen Anfrage wechseln",
        "help.arrow_keys": "Sie können auch die Pfeiltasten ↑↓ auf Ihrer Tastatur zum Blättern nutzen",
        "help.email_open": "Klicken Sie auf das Briefumschlag-Symbol um die damals versendete E-Mail zu lesen",
        "help.email_nav": "Auch in der E-Mail-Ansicht können Sie mit Vor/Zurück durch die Einträge blättern",
        "help.email_links": "E-Mail-Adressen und Internetadressen in den Angaben sind direkt anklickbar",
        "help.form_filter": "Oben rechts können Sie eine Auswahl treffen welches Formular Sie ansehen möchten",
        "help.column_filters": "Über \"Filter anzeigen\" können Sie die Liste nach bestimmten Begriffen durchsuchen",
        "help.columns_config": "Über das Spalten-Symbol oben rechts können Sie festlegen welche Spalten angezeigt werden",
        "Bulk action": "Mehrere Einträge bearbeiten",
        "help.bulk_select": "Setzen Sie die Häkchen links in der Zeile um mehrere Einträge auf einmal auszuwählen",
        "help.bulk_action": "Wählen Sie dann oben rechts eine Aktion aus und klicken Sie auf \"Ausführen\"",
        "help.bulk_delete": "Mit \"Löschen\" werden alle ausgewählten Einträge dauerhaft entfernt",
        "help.bulk_export": "Mit \"CSV exportieren\" können Sie die Einträge als Tabelle herunterladen und in Excel öffnen",
        "help.csv_export": "Es werden immer nur die Einträge exportiert die aktuell in der Liste sichtbar sind",
        "help.csv_filters": "Nutzen Sie die Filter um gezielt nur bestimmte Einträge zu exportieren",
        "Attachments": "Anhänge",
        "Cc": "CC",
        "Bcc": "BCC",
        "Export CSV": "CSV exportieren",
        "Previous": "Vorheriger",
        "Next": "Nächster"
    }
}
</i18n>

<script>

import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo'
import AuthApi from '@/store/api/system/auth';
import { ensureFreshToken } from '@/helpers';
import FormEntryApi from '@/extensions/forms/store/api/entry';

import pinia from '@/pinia';
import { useFormEntryStore, useSetupStore, useFormsEntryStore } from '@/stores';

import { timestamp2date } from '@/filters'

import PaginatedItems from '@/components/PaginatedItems'
import Tabs from '@/extensions/forms/views/Partials/Tabs'
import CheckAll from '@/components/CheckAll';

export default {
    name: 'FormEntries',
    filters: {
        timestamp2date,
    },
    data() {
        return {
            // loading: true,
            showInfo: false,
            fieldsDrawer: {
                visible: false,
                title: '',
                item: null,
                fields: [],
                index: -1,
            },
            modal: {
                visibility: false,
                title: '',
                subject: '',
                from: '',
                to: '',
                cc: '',
                bcc: '',
                datetime: null,
                attachments: [],
                loading: false,
                index: -1,
                item: null,
            },
            disable: {
                showFilters: false,
            },
            bulk: {
                action: undefined,
                options: [
                    // { value: 'change-status', label: this.$t('Change status...') },
                    { value: 'delete', label: this.$t('Delete...') },
                    { value: 'export-csv', label: this.$t('Export CSV') },
                    // { value: 'status-paid', label: 'Status (bezahlt)' },
                    // { value: 'status-shipping', label: 'Status (versendet)' },
                    // { value: 'status-packed', label: 'Status (wird gepackt)' }
                    // { value: 'export-stock', label: this.$t('Export stocks') },
                ],
                modal: {
                    visibility: false,
                    width: '740px',

                    title: undefined,
                    body: undefined,
                    buttons: {
                        left: [
                            {
                                size: 'mini',
                                icon: 'el-icon-fa-times fas',
                                label: this.$t('Dismiss'),
                                action: this.closeBulkModal,
                            }
                        ],
                        right: [],
                    }
                }
            },
        }
    },
    components: {
        PaginatedItems,
        Tabs,
        CheckAll
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true)
            if (reload) this.initialize()
        },
    },
    computed: {
        bulkSelection() {
            let checked = 'none';
            const total = _.get(this.formEntriesPaginated, 'pageInfo.total') || 0;

            const selection = this.formEntriesPaginated.pageInfo.selection;

            if (selection.type === 'exclusive' && selection.identifiers.length < total) checked = 'all';
            else if (selection.type === 'inclusive' && selection.identifiers.length) {
                checked = 'visible';
            }
            return checked;
        },
        selectionIndeterminate() {
            let indeterminate = false;

            const selection = this.formEntriesPaginated.pageInfo.selection;

            if (selection.type === 'exclusive' && selection.identifiers.length) indeterminate = true;
            else if (selection.type === 'inclusive' && selection.identifiers.length) {
                const items = _.get(this.formEntriesPaginated, 'items') || [];
                const currentPageSelection = items.filter(el => selection.identifiers.includes(parseInt(el.id)));
                indeterminate = currentPageSelection.length < items.length;
            }
            return indeterminate;
        },
        showFilters() {
            return this.hasFilters || _.get(this.formEntriesPaginated, 'showFilters') || false
        },
        hasFilters() {
            return !_.isEmpty(this.filters)
        },
        filters() {
            let filters = _.cloneDeep(this.formEntriesPaginated.filters)
            delete filters.cms
            return filters
        },
        formsEntryStore() {
            return useFormsEntryStore();
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        debounce() {
            return useSetupStore().debounce;
        },
        loading() {
            return this.formsEntryStore.loading;
        },
        formEntriesPaginated() {
            return this.formsEntryStore.formEntriesPaginated;
        },
        sort() {
            var variables = this.formEntriesPaginated.variables;
            var defaultSort = this.formEntriesPaginated.defaultSort || { field: 'created_at', direction: 'desc' };
            var order = (variables.order !== undefined && variables.order !== '') ? variables.order : defaultSort.field;
            var direction = (variables.direction !== undefined && variables.direction !== '') ? variables.direction : defaultSort.direction;
            return { field: order, direction: direction };
        },
        setupStore() {
            return useSetupStore(pinia);
        },
        fieldsDrawerGlobalPos() {
            const { currentPage, perPage } = this.formEntriesPaginated.pageInfo
            return (currentPage - 1) * perPage + this.fieldsDrawer.index + 1
        },
        modalGlobalPos() {
            const { currentPage, perPage } = this.formEntriesPaginated.pageInfo
            return (currentPage - 1) * perPage + this.modal.index + 1
        },
        allColumns() {
            return (this.formEntriesPaginated.allColumns || []).filter(c => c.key !== 'fields')
        },
        activeColumns() {
            return (this.formEntriesPaginated.activeColumns || []).filter(c => c.key !== 'fields')
        },
        formNameOptions() {
            const col = (this.formEntriesPaginated.allColumns || []).find(c => c.key === 'form_name');
            return col?.filter?.options || [];
        },
        formNameFilter() {
            return _.get(this.formEntriesPaginated.filters, 'form_name.match', '');
        },
    },
    methods: {
        isChecked(id) {
            let checked = false;

            const selection = this.formEntriesPaginated.pageInfo.selection;
            switch (selection.type) {
                case 'inclusive':
                    checked = !!~selection.identifiers.map(el => parseInt(el)).indexOf(parseInt(id));
                    break;

                case 'exclusive':
                    checked = !~selection.identifiers.map(el => parseInt(el)).indexOf(parseInt(id));
                    break;
            }
            return checked;
        },
        downloadFile(event) {
            if (!_.get(event, 'target.href')) return

            let element = document.createElement('a');
            element.setAttribute('href', event.target.href);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();
            document.body.removeChild(element);
        },
        initialize() {
            this.updateLoading(true)
            this.refetch()
        },
        // addFormEntry() {
        //     // const params = { id: 'new' }
        //     // router.push({ name: 'event-main', params })
        // },
        // handleClick(item) {
        //     // const params = { id: item.id }
        //     // router.push({ name: 'event-main', params })
        // },
        handleSizeChange(itemsPerPage) {
            this.updateLoading(true)
            this.defineItemsPerPage(itemsPerPage)
            this.refetch()
        },
        handleCurrentChange(currentPage) {
            this.updateLoading(true)
            this.defineCurrentPage(currentPage)
            this.refetch()
        },
        handleColsShow(visibleColumns) {
            this.defineActiveColumns(visibleColumns)
            // apolloClient.cache.reset()
            apolloClient.clearStore()
        },
        // Opening an entry is what "read" means here — same as the inbox.
        markEntrySeen(item) {
            if (!item || item.read_at) return;

            useFormEntryStore()
                .markRead(item.id, true)
                .then((updated) => {
                    // Patch the row in place; a refetch would jump the list.
                    this.$set(item, 'read_at', updated ? updated.read_at : Math.floor(Date.now() / 1000));
                })
                .catch(() => {});
        },
        toggleEntryRead(item) {
            const read = !item.read_at;

            useFormEntryStore()
                .markRead(item.id, read)
                .then((updated) => {
                    this.$set(item, 'read_at', updated ? updated.read_at : null);
                })
                .catch(() => {});
        },
        // Hand over to the ticket this entry became; it is worked on there.
        openTicket(ticket) {
            this.$router.push({ name: 'ticket-detail', params: { id: ticket.id } })
        },
        openFieldsDrawer(item) {
            this.markEntrySeen(item);
            const fields = (item.fields || []).filter(f => {
                if (!f.title) return false
                if (f.type === 'upload') return (f.files && f.files.length > 0) || !!f.value
                if (f.type === 'multi-select') return f.values && f.values.length > 0
                return !!f.value
            })
            const index = (this.formEntriesPaginated.items || []).findIndex(i => i.id === item.id)
            this.fieldsDrawer.title = item.subject || this.$t('Form fields')
            this.fieldsDrawer.item = item
            this.fieldsDrawer.fields = fields
            this.fieldsDrawer.index = index
            this.fieldsDrawer.visible = true
        },
        async navigateFieldsDrawer(direction) {
            const items = this.formEntriesPaginated.items || []
            const nextIndex = this.fieldsDrawer.index + direction
            if (nextIndex >= 0 && nextIndex < items.length) {
                this.openFieldsDrawer(items[nextIndex])
            } else {
                const newItems = await this.loadAdjacentPage(direction)
                if (!newItems) return
                const item = direction === 1 ? newItems[0] : newItems[newItems.length - 1]
                if (item) this.openFieldsDrawer(item)
            }
        },
        resetFieldsDrawer() {
            this.fieldsDrawer = { visible: false, title: '', item: null, fields: [], index: -1 }
        },
        handleFormNameFilterChange(value) {
            const filterObject = {
                key: 'form_name',
                match: value || '',
                like: '',
                from: '',
                to: '',
                in: [],
            };
            this.handleFilterInputChange('form_name', filterObject, false);
        },
        handleFilterInputChange(key, value, debounce = true) {
            this.defineFilterValue({ key, value })
            this.defineCurrentPage(1)
            if (debounce) this.debouncedRefetch()
            else this.refetch()
        },
        handleSortInputChange(key, value) {
            this.defineSort({ key, value })
            this.defineCurrentPage(1)
            this.refetch()
        },
        toggleFilterVisiblity() {
            const visible = this.showFilters

            let value = false
            if (!visible) value = true

            this.disable.showFilters = true
            this.defineFilterVisibility(value)
            this.saveFilterVisibility({ scope: 'ex', key: 'form_entry', value })
                .finally(() => this.disable.showFilters = false)
        },
        handleBulkAction(action = undefined) {
            if (!action) action = this.bulk.action;

            const completeRequest = ({ actions, data }) => {
                let promises = [];
                if (actions && actions.length) {
                    actions.forEach(async (action, i) => {
                        switch (action) {
                            case 'download-file':
                                promises.push(
                                    new Promise(async (resolve, reject) => {
                                        if (!data || !data.length || !data[i]) return reject('missing file in response');

                                        const file = data[i].split('/')
                                        const item = {
                                            id: file[0],
                                            name: file[1],
                                        }

                                        const storageRoute = _.trim(
                                            `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`,
                                            '/'
                                        );
                                        const token = await ensureFreshToken();
                                        const table = 'files';
                                        const link = `${storageRoute}/${table}/${item.id}/${encodeURIComponent(item.name)}?download&token=${token}`;

                                        let element = document.createElement('a');
                                        element.setAttribute('href', link);

                                        element.style.display = 'none';
                                        document.body.appendChild(element);

                                        element.click();
                                        document.body.removeChild(element);

                                        return resolve();
                                    })
                                )
                                break;


                            case 'refetch-list':
                                await apolloClient.clearStore();
                                promises.push(new Promise(async (resolve) => {
                                    await this.refetch();
                                    resolve();
                                }))
                                break;

                            default:
                                // eslint-disable-next-line
                                return reject('requested action is not supported');
                        }
                    })
                }

                return Promise.all(promises);
            }
            let total;
            switch (action) {
                case 'delete':
                    total = this.formEntriesPaginated.pageInfo.selection.total;
                    // show dialog
                    this.bulk.modal.title = this.$t('Do you really want to delete {total} form entries?', { total });
                    this.bulk.modal.width = '360px';

                    let confirmText = this.$t('Delete {total} form entries', { total });

                    if (total === 1) {
                        this.bulk.modal.title = this.$t('Do you really want to delete the selected form entry?');
                        confirmText = this.$t('Delete');
                    }

                    this.bulk.modal.buttons.right = [
                        {
                            size: 'mini',
                            type: 'danger',
                            icon: 'el-icon-fa-trash-alt fas',
                            label: confirmText,
                            action: () => this.handleBulkAction('delete:soft'),
                        }
                    ];

                    this.bulk.modal.visibility = true;
                    break;

                case 'export-csv':
                case 'delete:soft':
                case 'change-status:enabled':
                case 'change-status:disabled':
                case 'export-stock':
                    this.bulk.modal.visibility = false;
                    this.bulk.action = undefined;

                    this.updateLoading(true);
                    this.processPaginationBulkAction(action)
                        .then(data => {
                            completeRequest(data)
                                .then(() => {
                                    if (action === 'delete:soft') {
                                        this.resetBulkSelection();
                                        if (this.fieldsDrawer.visible) this.resetFieldsDrawer();
                                        if (this.modal.visibility) this.resetModal();
                                    }

                                    this.$notify.success({
                                        title: this.$t('Bulk action processed successfully!'),
                                        iconClass: 'fas el-icon-fa-check',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    });
                                })
                                .finally(() => {
                                    this.updateLoading(false)
                                })
                        })
                        .catch(err => {
                            // eslint-disable-next-line
                            console.error(err);
                            this.updateLoading(false);

                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Bulk action could not be processed.'),
                                iconClass: 'fas el-icon-fa-xmark',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        });
                    break;

                default:
                    this.updateLoading(false);
                    break;
            }
        },
        closeBulkModal() {
            this.bulk.modal.visibility = false;
        },
        resetBulkModal() {
            this.bulk.modal = {
                visibility: false,
                width: '740px',

                title: undefined,
                body: undefined,
                buttons: {
                    left: [
                        {
                            size: 'mini',
                            icon: 'el-icon-fa-times fas',
                            label: this.$t('Dismiss'),
                            action: this.closeBulkModal,
                        }
                    ],
                    right: [],
                }
            };
        },
        mailify(text) {
            if (!text) return text
            const escaped = String(text)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
            return escaped.replace(
                /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g,
                '<a href="mailto:$1">$1</a>'
            )
        },
        linkify(text) {
            if (!text) return text
            const escaped = String(text)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
            return escaped
                .replace(
                    /(https?:\/\/[^\s]+)/g,
                    '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
                )
                .replace(
                    /(?<!href="mailto:)([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g,
                    '<a href="mailto:$1">$1</a>'
                )
        },
        getAdditionalFormFieldValue(field) {
            // get values for multi select and files for upload
            switch (field.type) {
                case 'multi-select':
                    return (field.values || []).map(el => el.value).join(', ');

                case 'upload':
                    return (field.files || []).map(el => el.name).join(', ');

                default:
                    return field.value
            }
        },
        getLink(file) {
            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`, '/')
            let table = 'files'

            const token = AuthApi.getToken()
            return `${storageRoute}/${table}/${file.id}/${file.name}?token=${token}`
        },
        getDownloadLink(file) {
            return `${this.getLink(file)}&download`
        },
        openModal(item) {
            this.markEntrySeen(item);
            const index = (this.formEntriesPaginated.items || []).findIndex(i => i.id === item.id)
            this.modal.title = item.subject || this.$t('Sent email')
            this.modal.subject = item.subject
            this.modal.from = item.created_by_name
                ? `${item.created_by_name} <${item.created_by_email}>`
                : item.created_by_email
            this.modal.to = item.to || ''
            this.modal.cc = item.cc || ''
            this.modal.bcc = item.bcc || ''
            this.modal.datetime = timestamp2date(item.created_at, this.$t('yyyy-MM-dd') + ', HH:mm')
            this.modal.attachments = []
            this.modal.index = index
            this.modal.item = item

            item.fields.forEach(field => {
                if (field.type === 'upload' && field.files.length) {
                    this.modal.attachments.push(...field.files)
                }
            })

            this.modal.visibility = true
            this.modal.loading = true

            // Render the actual notification email through the backend preview
            // controller (reflects the tenant's customized template), then inject
            // the HTML into the iframe — same mechanism as the purchase email preview.
            this.$nextTick(() => {
                const iframe = this.$refs['preview-iframe']
                FormEntryApi.renderEmail(item.id)
                    .then(({ data }) => {
                        if (data && data.subject) {
                            this.modal.subject = data.subject
                            if (!item.subject) this.modal.title = data.subject
                        }
                        if (iframe && iframe.contentWindow) {
                            iframe.contentWindow.document.open()
                            iframe.contentWindow.document.write(data.document || '')
                            iframe.contentWindow.document.close()
                        }
                    })
                    .catch(() => {
                        this.$notify.error({
                            title: this.$t('Error loading email preview'),
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        })
                    })
                    .finally(() => {
                        this.modal.loading = false
                    })
            })
        },
        async navigateModal(direction) {
            const items = this.formEntriesPaginated.items || []
            const nextIndex = this.modal.index + direction
            if (nextIndex >= 0 && nextIndex < items.length) {
                const item = items[nextIndex]
                if (item.created_by_email && item.email_data && item.email_data.length) {
                    this.openModal(item)
                }
            } else {
                const newItems = await this.loadAdjacentPage(direction)
                if (!newItems) return
                const item = direction === 1 ? newItems[0] : newItems[newItems.length - 1]
                if (item && item.created_by_email && item.email_data && item.email_data.length) {
                    this.openModal(item)
                }
            }
        },
        async loadAdjacentPage(direction) {
            const { currentPage, lastPage } = this.formEntriesPaginated.pageInfo
            const nextPage = currentPage + direction
            if (nextPage < 1 || nextPage > lastPage) return null
            this.updateLoading(true)
            this.defineCurrentPage(nextPage)
            await this.fetchFormEntriesPaginated()
            this.updateLoading(false)
            return this.formEntriesPaginated.items || []
        },
        resetModal() {
            this.modal = {
                visibility: false,
                title: '',
                subject: '',
                from: '',
                to: '',
                cc: '',
                bcc: '',
                datetime: null,
                attachments: [],
                loading: false,
                index: -1,
                item: null,
            }
        },
        refetch() {
            this.updateLoading(true)

            // always add the cms id to filters
            const cmsID = this.activeCms.id
            const filter = {
                key: 'cms',
                match: cmsID,
            }
            this.defineFilterValue({ key: 'cms', value: filter })

            this.fetchFormEntriesPaginated()
                .then(() => this.updateLoading(false))
                .catch(err => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err)
                    this.updateLoading(false)

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Form entry list could not be fetched.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
        },
        debouncedRefetch: _.debounce(function () { // function scope is needed here
            this.updateLoading(true)
            this.refetch()
        }, useSetupStore(pinia).debounce || 300),
        // Pinia store methods
        fetchFormEntriesPaginated() {
            return this.formsEntryStore.fetchFormEntriesPaginated();
        },
        processPaginationBulkAction(action) {
            return this.formsEntryStore.processPaginationBulkAction(action);
        },
        updateLoading(value) {
            this.formsEntryStore.updateLoading(value);
        },
        defineItemsPerPage(perPage) {
            this.formsEntryStore.defineItemsPerPage(perPage);
        },
        defineCurrentPage(currentPage) {
            this.formsEntryStore.defineCurrentPage(currentPage);
        },
        defineActiveColumns(columns) {
            this.formsEntryStore.defineActiveColumns(columns);
        },
        defineSort(payload) {
            this.formsEntryStore.defineSort(payload);
        },
        defineFilterValue(payload) {
            this.formsEntryStore.defineFilterValue(payload);
        },
        defineFilterVisibility(value) {
            this.formsEntryStore.defineFilterVisibility(value);
        },
        checkVisible(payload) {
            this.formsEntryStore.paginationBulkSelectionCheckVisible(payload);
        },
        checkAll(payload) {
            this.formsEntryStore.paginationBulkSelectionCheckAll(payload);
        },
        checkItem(item) {
            this.formsEntryStore.paginationBulkSelectionCheckItem(item);
        },
        resetBulkSelection() {
            this.formsEntryStore.paginationBulkSelectionReset();
        },
        deleteDrawerItem(item) {
            this.formsEntryStore.paginationBulkSelectionReset();
            this.formsEntryStore.paginationBulkSelectionCheckItem(item);
            this.handleBulkAction('delete');
        },
        saveFilterVisibility(payload) {
            return this.setupStore.saveFilterVisibility(payload);
        },
        handleKeydown(e) {
            const activeDrawer = this.fieldsDrawer.visible ? 'fields'
                : this.modal.visibility ? 'email'
                : null
            if (!activeDrawer) return
            if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
                e.preventDefault()
                activeDrawer === 'fields' ? this.navigateFieldsDrawer(-1) : this.navigateModal(-1)
            } else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
                e.preventDefault()
                activeDrawer === 'fields' ? this.navigateFieldsDrawer(1) : this.navigateModal(1)
            }
        },
    },
    mounted() {
        this.initialize()
        window.addEventListener('keydown', this.handleKeydown)
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleKeydown)
    },
}
</script>

<style lang="sass" scoped>
    .table-top .row .middle
        flex: 1

    .form-filter
        min-width: 140px
        max-width: 220px

    ::v-deep thead tr.filters > th.actions
        vertical-align: bottom !important
        .col-left
            padding-left: 10px
            padding-bottom: 4px

    .field
        max-width: 400px

    .field,
    .entry
        i
            color: $color-grey-text
        p.value
            white-space: pre-wrap
            margin: 0
        & + .field
            margin-top: 10px
    a.file
        display: block

    .modal-footer
        display: flex
        justify-content: space-between

    .fields-drawer
        ::v-deep .el-drawer__body
            overflow-y: auto
            display: flex
            flex-direction: column
        &__body
            flex: 1
            padding: 0 20px 20px
        // Same handover strip the inbox thread carries, in the same place: at
        // the bottom, where the next action would be.
        &__ticket
            display: flex
            align-items: center
            gap: 10px
            padding: 10px 20px
            border-top: 1px solid #e4e7ed
            background: #f4f7ff
            color: #606266
            font-size: .78rem
            text-decoration: none
            transition: background .15s
            &:hover
                background: #ecf3ff
                .fields-drawer__ticket-go
                    color: $--color-primary
            > .fa-ticket
                flex-shrink: 0
                color: $--color-primary
            &-text
                display: flex
                align-items: baseline
                gap: 8px
                min-width: 0
                // The drawer is narrow: only the subject may truncate, the
                // ticket number itself must stay on one line.
                strong
                    white-space: nowrap
            &-subject
                overflow: hidden
                text-overflow: ellipsis
                white-space: nowrap
                color: #909399
            &-go
                display: flex
                align-items: center
                gap: 5px
                margin-left: auto
                flex-shrink: 0
                color: #909399
                transition: color .15s
        &__nav
            padding: 12px 20px
            border-top: 1px solid #e4e7ed
            display: flex
            align-items: center
            justify-content: space-between
            .nav-pos
                flex: 1
                text-align: center
                font-size: 12px
                color: #909399
            .nav-btns
                display: flex
                .el-button + .el-button
                    margin-left: 8px
        &__field
            padding: 12px 0
            border-bottom: 1px solid #f0f2f5
            &:last-child
                border-bottom: none
        &__field-title
            font-size: 12px
            color: #909399
            font-weight: 500
            margin-bottom: 4px
        &__field-value
            font-size: 13px
            color: #303133
            white-space: pre-wrap
            word-break: break-word
            a.file
                display: block
            &.field-tags
                display: flex
                flex-wrap: wrap
                gap: 6px
                white-space: normal
            .field-tag
                display: inline-block
                background: #ecf5ff
                color: #409eff
                border: 1px solid #d9ecff
                border-radius: 4px
                padding: 2px 8px
                font-size: 12px
                line-height: 1.6

    .email-preview-drawer
        ::v-deep .el-drawer__body
            overflow-y: auto
            display: flex
            flex-direction: column
        .eml-preview--with-nav
            flex: 1
            overflow: hidden
            display: flex
            flex-direction: column
        .eml-preview__nav
            padding: 12px 20px
            border-top: 1px solid #e4e7ed
            display: flex
            align-items: center
            justify-content: space-between
            .nav-pos
                flex: 1
                text-align: center
                font-size: 12px
                color: #909399
            .nav-btns
                display: flex
                .el-button + .el-button
                    margin-left: 8px

    .eml-preview
        padding: 0
        &__body-scroll
            flex: 1
            overflow-y: auto
            background: #f5f7fa
            padding: 0
        &__iframe
            width: 100%
            height: 100%
            min-height: 70vh
            border: 0
            background: #fff
        .eml-meta
            background: #fff
            padding: 0 20px 15px
            font-size: 0.8rem
            display: grid
            grid-template-rows: auto auto
            grid-template-columns: auto auto
            .from-to
                b
                    margin-right: 4px
                > div
                    margin-bottom: 2px
            .pill
                &:not(:last-child):after
                    content: ', '
                    margin-right: 2px
            .from-to b + span.pill
                margin-left: 4px
            .subject
                grid-row: 2
                margin-top: 1rem
                b + span
                    margin-left: 4px
                span
                    font-weight: 600
            .attachments
                grid-column: 2
                text-align: right
                display: flex
                flex-direction: column
                align-items: flex-end
                ul
                    list-style: none
                    padding: 0
                    margin: 4px 0 0
        &__body
            margin-top: 16px
            border: 1px solid #e4e7ed
            border-radius: 6px
            overflow: hidden
            padding: 20px 24px
            font-size: 13px
            line-height: 1.7
            background: #fff
            margin-right: 4px
            .entry
                margin-bottom: 1em
                &:last-child
                    margin-bottom: 0
                .title
                    font-weight: bold
                    font-size: 1.05rem
                    margin-bottom: 2px
                p.value
                    white-space: pre-wrap
                    margin: 0
                i
                    color: $color-grey-text
                    font-style: normal
                    font-size: 0.85em
                    display: block

    .fe-info-btn
        margin-left: 4px
        &.is-active
            background: #ecf5ff !important

    .fe-info-content
        background: #f0f7ff
        border: 1px solid #c6e0ff
        border-radius: 6px
        padding: 20px 24px 18px
        font-size: 13px
        line-height: 1.7
        color: #4b5563
        position: relative
        margin: 15px
        h4
            margin: 0 0 16px
            font-size: 15px
            font-weight: 700
            color: #1e3a5f
            border-bottom: 2px solid #c6e0ff
            padding-bottom: 10px
        ul
            margin: 6px 0 0
            padding-left: 18px
            li
                margin-bottom: 5px
                font-size: 13px
        b
            color: #1e3a5f
        .fe-info-description
            margin: 0 0 16px
            color: #6b7280
            font-size: 13px
            line-height: 1.6

    .fe-info-grid
        display: grid
        grid-template-columns: repeat(auto-fill, minmax(260px, 1fr))
        gap: 16px 32px

    .fe-info-section
        .fe-info-title
            font-weight: 700
            color: #2563eb
            font-size: 12px
            text-transform: uppercase
            letter-spacing: 0.06em
            margin-bottom: 6px
            display: flex
            align-items: center
            gap: 5px

    .fe-info-close
        position: absolute
        top: 12px
        right: 14px
        background: none
        border: none
        cursor: pointer
        color: #909399
        font-size: 18px
        line-height: 1
        padding: 2px
        &:hover
            color: #303133

    .fe-info-slide-enter-active,
    .fe-info-slide-leave-active
        transition: all .2s ease

    .fe-info-slide-enter,
    .fe-info-slide-leave-to
        opacity: 0
        transform: translateY(-6px)
</style>
